import {
	PRIVATE_FREEFORM_API_KEY_ENV,
	PRIVATE_FREEFORM_API_VERSION_ENV,
	PUBLIC_API_URL_ENV,
} from 'tools/environments';

import { GetArticlesBySection } from './types';

export const getArticlesBySection = async (
	sectionId: number
): Promise<GetArticlesBySection> => {
	const apiUrl = `${PUBLIC_API_URL_ENV}/helpcentre/articlesbysection?sectionid=${sectionId}`;

	const response: GetArticlesBySection = await fetch(apiUrl, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			'Ocp-Apim-Subscription-Key': `${PRIVATE_FREEFORM_API_KEY_ENV}`,
			'Api-Version': `${PRIVATE_FREEFORM_API_VERSION_ENV}`,
		},
	})
		.then((res) => res.json())
		.catch((error) => {
			console.error('Error fetching articles by section:', error);
			return [];
		});

	return response;
};
